<template>
  <CRow>
    <CCol col="12" md="7">
        <CCard>
    <CCardHeader>
        <p> <img src="img/factory.svg" style="width:20px">  ChillingCenter</p>
        </CCardHeader>
           <CCardBody>
  <CDataTable
          :items="chilingItem"
          :fields="fields"
          table-filter
          items-per-page-select
          :items-per-page="10"
        
          pagination
          clickable-rows
          hover
          @row-clicked="rowClicked"
          caption="Breed"
        />
        </CCardBody>
        </CCard>
    </CCol>
    <CCol col="6" md="5">
      <CCard>
          <CCardHeader>
           <p>  <img src="img/factory.svg" style="width:20px">  ChillingCenter Details</p>
           
          </CCardHeader>
          <CCardBody>
            <CForm>
                  
             <CInput
               
                label="Code"
                horizontal
                autocomplete="name"
                name="Code"
                id="Code"
                required
                v-model="Code"
              />
                
                  
             <CInput
               
                label="Name"
                horizontal
                autocomplete="name"
                  name="Name"
                id="Name"
                required
                 v-model="Name"
              />
                 <CInput
               
                label="Contact Person"
                horizontal
                autocomplete="name"
                name="ContactPerson"
                id="ContactPerson"
                required
                 v-model="ContactPerson"
              />
                 <CInput
               
                label="Email"
                horizontal
                autocomplete="name"
                 name="Email"
                id="Email"
                required
                 v-model="email"
              />
                 <CInput
               
                label="ContactNumber"
                horizontal
                autocomplete="name"
                 name="ContactNumber"
                id="ContactNumber"
                required
                 v-model="ContactNumber"
              />
                
               
 
             </CForm>

          </CCardBody>
           <CCardFooter>
                  <CButton color="info" style="width:100px" v-if="addButton" @click="addChilling">
                    <CIcon name="cilPencil" />&nbsp;Add
                  </CButton>&nbsp;
                  <CButton
                    color="success"
                    style="width:100px"
                    v-if="saveButton"
                    @click="updateChilling"
                  >
                    <CIcon name="cilCheck" />&nbsp;Save
                  </CButton>&nbsp;
                  <CButton
                    color="danger"
                    style="width:100px"
                    v-if="deleteButton"
                    @click="deleteChilling"
                  >
                    <CIcon name="cilXCircle" />&nbsp;Delete
                  </CButton>&nbsp;
<CButton color="success" style="width:100px" v-if="EditsaveButton" @click="addChilling">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;


                  <CButton
                    color="secondary"
                    style="width:100px"
                    v-if="cancelButton"
                    @click="CancelChilling"
                  >
                    <CIcon name="cilWarning" />&nbsp;Cancel
                  </CButton> &nbsp;
                   <CButton
                    color="info"
                   
                    v-if="addnewButton"
                    @click="addChillingplus"
                  >
                    <CIcon name="cilPencil" />&nbsp;Add New
                  </CButton>
                </CCardFooter>
        </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from '../../tables/Table'
import { APIService } from "../../../apiservice.js";
import Swal from "sweetalert2";
export default {
     components: { CTableWrapper },
 
  data () {
    return{
      chilingItem:[],
      editchilling:[],
      Code:null,
      Name:"",
      ContactNumber:"",
      email:"",
      ContactPerson:"",
     addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton:true,
      cancelButton:false,
      EditsaveButton:false,
       fields: [
      {
        key: "Code",
        sortable: true
      },
      {
        key: "Name",
        sortable: true
      },
       
         {
        key: "ContactNumber",
        sortable: true
      },
        {
        key: "email",
        sortable: true
      },
      {
        key: "ContactPerson",
        sortable: true
      },
    
      
    ],
   
    }
  },
  methods: {
     getchillingList() {
      APIService.chillingList().then(res => {
        if (res.status == 200) {
          this.chilingItem = res.data;
          this.Code= this.chilingItem[0].Code
          this.Name = this.chilingItem[0].Name;
      this.email = this.chilingItem[0].email;
        this.ContactPerson = this.chilingItem[0].ContactPerson;
      this.ContactNumber =this.chilingItem[0].ContactNumber;
        }
      });
    },
  
    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editchilling = item;
      this.Code = item.Code;
      this.Name = item.Name;
      this.email = item.email;
        this.ContactPerson = item.ContactPerson;
      this.ContactNumber = item.ContactNumber;
       this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton =false;
      this.addnewButton=true;
      this.EditsaveButton=false;
    },
    addChilling() {
      let Code = this.Code;
      let Name = this.Name;
      let ContactPerson = this.ContactPerson;
        let email = this.email;
      let ContactNumber = this.ContactNumber;
      let data = {
      Code,
      Name,
      ContactPerson,
      email,
      ContactNumber
      };
      APIService.saveChilling(data).then(res => {
        if (res.status == 200) {
          this.Code = null;
          this.Name = "";
          this.ContactPerson = "";
          this.email="",
          this.ContactNumber=""
          this.getchillingList();
            Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    addChillingplus(){
           this.Code = null;
          this.Name = "";
          this.ContactPerson = "";
          this.email="",
          this.ContactNumber=""
        this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton =true;
          this.addnewButton=false;
           this.EditsaveButton=true
          return getchillingList();
    },
    
    CancelChilling(){
          this.Code = null;
          this.Name = "";
          this.ContactPerson = "";
          this.email="",
          this.ContactNumber=""
        this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton =false;
          this.addnewButton=true;
           this.EditsaveButton=false,
         this.getchillingList();
    },
    updateChilling() {
      let id = this.editchilling._id;
        this.Code = null;
          this.Name = "";
          this.ContactPerson = "";
          this.email="",
          this.ContactNumber=""
      let value = {
          Code,
      Name,
      ContactPerson,
      email,
      ContactNumber
      };
      let data = { id, value };
      APIService.chillingUpdate(data).then(res => {
        if (res.status == 200) {
             this.Code = null;
          this.Name = "";
          this.ContactPerson = "";
          this.email="",
          this.ContactNumber=""
            this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
           this.cancelButton =false;
           this.addnewButton=true;
        this.getchillingList();
          Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    deleteChilling() {
      const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Deleted!',
      'Your file has been deleted.',
      'success'
    )
     this.delete();
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your imaginary file is safe :)',
      'error'
    )
  }
})

    },

    delete(){
      let id = this.editchilling._id;
      let data = { id };
      APIService.chillingDelete(data).then(res => {
        if (res.status == 200) {
          this.Code = null;
          this.Name = "";
          this.ContactPerson = "";
          this.email="",
          this.ContactNumber=""
             this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
           this.cancelButton =false;
             this.addnewButton=true;
              this.EditsaveButton=false,
          this.getchillingList();
        }
      });
    }
  },
  created() {
    // this.getBreedList();
    this.getchillingList();
  }
  
}
</script>
